<template>
    <base-list-with-heading class="mt-5">
        <template v-slot:header>
            <span class="text-base text-gray-800">Comment</span>
            <div class="mt-2 xl:mt-0 ml-0 xl:ml-auto flex flex-wrap items-center">
                <div class="px-2 py-1 text-xs rounded-full font-bold leading-tight flex items-center" :class="{'text-red-800 bg-red-200' : !comment.resolved, 'text-green-800 bg-green-200' : comment.resolved, 'text-yellow-800 bg-yellow-200': comment.planned}">
                    <div class="w-1 h-1 rounded-full" :class="{'bg-red-400' : !comment.resolved, 'bg-green-400' : comment.resolved, 'bg-yellow-400': comment.planned}"></div>
                    <span class="ml-1" v-if="comment.planned && !comment.resolved">Planned</span>
                    <span class="ml-1" v-if="!comment.planned && !comment.resolved">Ongoing</span>
                    <span class="ml-1" v-if="comment.resolved">Resolved</span>
                </div>
            </div>
        </template>

        <base-list-with-heading-entry>
            <div class="flex-1">
                <div class="text-gray-700 text-sm mt-2" v-if="comment.comment">
                    <p v-html="comment.comment"></p>
                </div>
            </div>
            <div class="mt-2 xl:mt-0 ml-0 xl:ml-auto flex flex-wrap flex-col width150">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" class="text-gray-500 inline" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                    <span
                        class="text-gray-600 text-sm ml-2"
                        v-tooltip="{
                        content: comment.created_at,
                        classes: 'inline-block z-10 py-2 px-3 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-sm opacity-100 transition-opacity duration-300 tooltip dark:bg-gray-700',
                        offset: 0
                    }"
                    >{{ comment.created_at_human_readable }}</span>
                </div>

                <div v-if="comment.resolved">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" class="text-gray-500 inline" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg>
                    <span class="text-gray-600 text-sm ml-2">Duration: {{ comment.readable_interription_duration }}</span>
                </div>
            </div>
        </base-list-with-heading-entry>
    </base-list-with-heading>
</template>

<script>
export default {
    props: {
        comment: {
            required: true,
            type: Object,
        },
    },
    computed: {
    },
}
</script>
